
const Loading = ({text}: {text?: string}) => {
  return (
    // bg-yellow-50
    <div className="flex flex-col items-center justify-center h-screen  text-gray-700  dark:text-white ">
      <img
        src={"/media/images/logo.png"}
        alt="Loading"
        className="w-28 xl:w-32"
      />
      <p className="mt-4 text-lg dark:text-white">{text || "Loading..."}</p>
    </div>
  );
};

export default Loading;
